import React from "react";

const FooterPage = () => (
  <footer className="mx-auto max-w-6xl px-4 py-8 text-sm text-slate-500 dark:text-slate-400">
    <div className="border-t border-sky-500/10 pt-6">
      {process.env.REACT_APP_NAME || "Stockage"} {process.env.REACT_APP_VER || ""}
    </div>
  </footer>
);

export default FooterPage;
